import { Routes, Route, Navigate } from "react-router-dom";
import RouteWrapper from "./route-wrapper/RouteWrapper";
import { RoutePaths } from "../../../util/constants";
import useAppRoutes from "./useAppRoutes";
import ProtectedRoute from "./protected-route/ProtectedRoute";

export default function AppRoutes() {
    const [routes] = useAppRoutes();

    return (
        <Routes>
            {routes.map((r) => (
                <Route
                    key={r.path}
                    path={r.path}
                    element={
                        <ProtectedRoute showRoute={r.showRoute} redirectTo={r.redirectTo}>
                            <RouteWrapper Component={r.component} Layout={r.layout} title={r.title} />
                        </ProtectedRoute>
                    }
                />
            ))}
            <Route path="*" element={<Navigate to={RoutePaths.HOME} replace />} />
        </Routes>
    );
}
